import * as R from 'ramda';

export const sortProductsByPopularityDesc = R.curry((properties, products) =>
    R.sortWith(properties.map(property => R.descend(R.prop(property))))(products)
);
